import React from 'react'
import Resx from '@/components/Resx'

const Forecasting = (props) => {
  const { forecasting } = props
  if (forecasting) { return (<span className='status status--unfinished'><Resx name='Reporting.Forecasting' /></span>) }
  return null
}

export {
  Forecasting
}



// WEBPACK FOOTER //
// ./src/components/reporting/forecasting.js